import styled from 'styled-components';

export const FormActionsContainer = styled.div`
  display: grid;
  height: 80px;
  grid-template-columns: 1fr auto;
  grid-template-rows: 1fr;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;

  @media only screen and (max-width: 800px) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const SelectWrapper = styled.div`
  width: 100%;
  min-width: 0;

  .view-select {
    width: 100%;
    min-width: 0;
  }
`;
